import type { TaskRuntimeState } from "./types";

type ActivityRuntime = Pick<TaskRuntimeState, "state" | "activity" | "admission_queue">;

export function assistantActivityLabel(runtime: ActivityRuntime): string | null {
  if (runtime.state === "stopping") return "正在停止任务";
  if (!["planning", "executing", "running"].includes(runtime.state)) return null;
  if (runtime.admission_queue?.status === "queued") {
    return `正在排队，前方还有 ${runtime.admission_queue.sessions_ahead} 个会话`;
  }
  if (runtime.activity !== undefined) return runtime.activity;
  return runtime.state === "planning" ? "正在思考" : "正在处理任务";
}

export function AssistantActivity({ label }: { label: string | null }) {
  if (!label) return null;
  return (
    <div className="assistant-activity" role="status" aria-live="polite" aria-atomic="true">
      <span className="assistant-activity-text">{label}</span>
    </div>
  );
}
